import LoadingIndicator from './icons/LoadingIndicator';

export enum LoadingSpinnerSize {
  Small,
  Huge,
}

interface ILoadingSpinnerProps {
  readonly size?: LoadingSpinnerSize;
}

function HugeLoadingSpinner() {
  return (
    <div className="w-screen h-screen flex flex-col bg-body items-center justify-center">
      <div className="flex items-center justify-center relative">
        <div className="z-10 rounded-full animate-spin-slow">
          <LoadingIndicator wrapperClassName="z-0 fixed inset-0 grow grid place-items-center" />
        </div>
      </div>
    </div>
  );
}

function SmallLoadingSpinner() {
  return (
    <div className="w-full flex items-center justify-center relative">
      <div className="z-10 rounded-full animate-spin-slow">
        <LoadingIndicator wrapperClassName="z-0 fixed inset-0 grow grid place-items-center" />
      </div>
    </div>
  );
}

export function LoadingSpinner({ size }: ILoadingSpinnerProps) {
  if (size === LoadingSpinnerSize.Small) {
    return <SmallLoadingSpinner />;
  }

  return <HugeLoadingSpinner />;
}
